import { render, staticRenderFns } from "./ItemCode.vue?vue&type=template&id=67b3191a&scoped=true&"
import script from "./ItemCode.vue?vue&type=script&lang=js&"
export * from "./ItemCode.vue?vue&type=script&lang=js&"
import style0 from "./ItemCode.vue?vue&type=style&index=0&id=67b3191a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3191a",
  null
  
)

export default component.exports